import React from 'react'
import { FormattedMessage } from 'react-intl'

export const NOT_FOUND_MESSAGE = (
    <FormattedMessage
        id='vehicles_table.not_found_message'
        defaultMessage='Не найдено техники, удовлетворяющей условиям поиска'
    />
)

export const NAME_COLUMN_TITLE = (
    <FormattedMessage
        id='vehicles_table.name_column'
        defaultMessage='Название'
    />
)

export const VEHICLE_NOT_READY_TOOLTIP = {
    id: 'vehicles_table.vehicle_not_ready_tooltip',
    message: (
        <FormattedMessage
            id='vehicle_temporary_not_ready'
            defaultMessage='Эта машина временно не готова вступить в бой'
        />
    ),
}

export const HEADER_TOOLTIPS = {
    nation: {
        id: 'vehicles_table.header.tooltips.nation.id',
        title: (
            <FormattedMessage
                id='vehicles_table.header.tooltips.nation.title'
                defaultMessage='Нация'
            />
        ),
        message: (
            <FormattedMessage
                id='vehicles_table.header.tooltips.nation.message'
                defaultMessage='Сортировать по нации.'
            />
        ),
    },
    type: {
        id: 'vehicles_table.header.tooltips.type.id',
        title: (
            <FormattedMessage
                id='vehicles_table.header.tooltips.type.title'
                defaultMessage='Тип'
            />
        ),
        message: (
            <FormattedMessage
                id='vehicles_table.header.tooltips.type.message'
                defaultMessage='Сортировать по типу техники.'
            />
        ),
    },
    name: {
        id: 'vehicles_table.header.tooltips.name.id',
        title: (
            <FormattedMessage
                id='vehicles_table.header.tooltips.name.title'
                defaultMessage='Название'
            />
        ),
        message: (
            <FormattedMessage
                id='vehicles_table.header.tooltips.name.message'
                defaultMessage='Сортировать по названию машин.'
            />
        ),
    },
}



// WEBPACK FOOTER //
// ./components/VehiclesTable/constants.jsx